import { useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { isSinglePageActive } from "../../utils/daynamicNavigation";
import Preloader from "../common/Preloader";
import { isoToDate } from "../../utils/helpers";
import { Button, Modal } from "react-bootstrap";
import { baseURL, handleNotOkHttpResponse } from "../../utils/misc";
import { toast } from "react-toastify";
import PackagingBasicForm from "./PackagingBasicForm";
import { CompanyIds, runningCompanyId } from "../../appSetup";

function PackagingTable({ packagingRecords,packagingRecord, crop,setPackagingRecord,
    allowEdit, handleModalShow, handleSubmit,showModal,handleModalClose,packagingId, allowModalEdit}) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [showPreloader, setShowPreloader] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const profileMenuItems = [
        {
            id: 1,
            name: "View",
            icon: "icon-eye1",
            onClick: (process) => {
                handleShowViewModal(process);
            },
        },
        {
            id: 2,
            name: "Edit",
            icon: "icon-edit1",
            authType: 'admin',
            onClick: (record) => {
                if (allowModalEdit) {
                    handleModalShow(record, true); // Open modal for editing
                } else {
                    // Redirect to edit page if modal edit is not allowed
                    window.location.href = `/packagingrecord/edit/${record.id}`;
                }
            },
        },
        {
            id: 3,
            name: "Delete",
            icon: "icon-delete",
            onClick: (process) => {
                handleShowDeleteModal(process);
            },
            authType: 'admin',
        }
    ];

    // Define the path pattern for user profiles
    const $ = require("jquery");

    useEffect(() => {
        if (packagingRecords && packagingRecords.length > 0) {
            //Initialize DataTable when users are available
            $(document).ready(function () {
                const dataTable = $("#data-table").DataTable();

                // Destroy DataTable if it exists
                if (dataTable) {
                    dataTable.destroy();
                }

                $("#data-table").DataTable({
                    // Add any required DataTable options here
                    columnDefs: [
                        { width: "12%", targets: 0 },
                        { width: "12%", targets: 1 },
                        { width: "12%", targets: 3 }
                    ]
                });
            });
        }
    }, [packagingRecords, $]);

    const handleShowViewModal = (record) => {
        setSelectedRecord(record);
        setShowViewModal(true);
    };

    const handleCloseViewModal = () => {
        setShowViewModal(false);
        setSelectedRecord(null);
    };

    const handleShowDeleteModal = (record) => {
        setSelectedRecord(record);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedRecord(null);
    };

    const handleRemovePackaging = async () => {
        if (!(user && user.user.token)) {
            navigate('/login');
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }

        setShowPreloader(true);
        try {
            if (!selectedRecord) {
                console.error('No selected Record');
                return;
            }

            const requestOptions = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                },
                redirect: "follow",
            };

            const response = await fetch(`${baseURL}/packagingrecords/${selectedRecord.id}`, requestOptions);
            if (response.ok) {
                toast.success("Packaging Record removed successfully");
                handleCloseDeleteModal();
                setShowPreloader(true);
                window.location.reload();
            } else {
                handleNotOkHttpResponse(response);
                return false;
            }
        } catch (error) {
            console.error("Error on removing Packaging Record:", error.message);
        } finally {
            setShowPreloader(false);
        }
    };

    return (
        <>
            <Preloader show={showPreloader} />
            <div className="card-body pt-0">
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

                        <div className="table-responsive">
                            <table id="data-table" className="table custom-table">
                                <thead className="thead-dark">
                                    <tr>
                                        <th>Code</th>
                                        <th>Date</th>
                                        <th>SSCC</th>
                                        <th>Packaging Material</th>
                                        {runningCompanyId !== CompanyIds.TropighaFarmsLtd &&<th>Packaging Type</th>}
                                        <th>Quantity Packaged</th>
                                        <th>Number of Packers</th>
                                        <th>Supervised By</th>
                                        <th><div className="float-end">Actions</div></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {packagingRecords && packagingRecords.length > 0 ? packagingRecords.map((packagingRecord, index) => (
                                        <tr key={index}>
                                            <td>{packagingRecord.code ? packagingRecord.code : '--'}</td>
                                            <td>{isoToDate(packagingRecord.date)}</td>
                                            <td>{packagingRecord.sscc ? packagingRecord.sscc : '--'}</td>
                                            <td>{packagingRecord.packagingMaterial.join(', ')}</td>
                                            {runningCompanyId !== CompanyIds.TropighaFarmsLtd && <td>{packagingRecord.packagingType}</td>}
                                            <td>{packagingRecord.quantityPackaged} {packagingRecord.quantityUnit}</td>
                                            <td>{packagingRecord.numberOfPackers}</td>
                                            <td>{packagingRecord.supervisedBy}</td>
                                            <td className="">
                                                <ul>
                                                    <li className="user_setting float-end" style={{ listStyle: "none" }}>
                                                        <div className="dropdown">
                                                            <Link
                                                                className="btn btn-secondary dropdown-toggle dn-1199 ms-2"
                                                                role="button"
                                                                to="#"
                                                                id={"dropdownMenuLink" + packagingRecord.id}
                                                                data-bs-toggle="dropdown"
                                                            >
                                                                Actions <i className="fa fa-caret-down"></i>
                                                            </Link>
                                                            <ul
                                                                className="dropdown-menu"
                                                                aria-labelledby={"dropdownMenuLink" + packagingRecord.id}
                                                            >
                                                                {profileMenuItems.map((actionMenuItem) => (
                                                                    <>
                                                                        {(!actionMenuItem.authType || (actionMenuItem.authType === "admin" && allowEdit)) &&
                                                                            <li key={packagingRecord.id + '-' + actionMenuItem.id}>
                                                                                {actionMenuItem.onClick ? (
                                                                                    <Link
                                                                                        to="#"
                                                                                        className="dropdown-item"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault(); // Prevent default anchor behavior
                                                                                            actionMenuItem.onClick(packagingRecord);
                                                                                        }}
                                                                                        style={
                                                                                            isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                ? { color: "#ff5a5f" }
                                                                                                : undefined
                                                                                        }
                                                                                    >
                                                                                        <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                    </Link>
                                                                                ) : (
                                                                                    <Link
                                                                                        to={actionMenuItem.routerPath + "/" + packagingRecord.id} // Changed href to to
                                                                                        className="dropdown-item"
                                                                                        style={
                                                                                            isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                ? { color: "#ff5a5f" }
                                                                                                : undefined
                                                                                        }
                                                                                    >
                                                                                        <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                    </Link>
                                                                                )}
                                                                            </li>
                                                                        }
                                                                    </>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    )) : (<tr><td colSpan="7" className="text-center"><em>No data available!</em></td></tr>)}
                                </tbody>
                            </table>
                            {/* Delete Modal */}
                            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                                <Modal.Header closeButton style={{ backgroundColor: 'rgb(36, 50, 74)' }}>
                                    <Modal.Title style={{ color: 'white' }}>Delete Packaging</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p className="mb-4">
                                        Are you sure you want to delete this packaging record?
                                    </p>
                                </Modal.Body>
                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button variant="secondary" style={{ color: '#fff', backgroundColor: '#6c757d', border: 'none' }} onClick={handleCloseDeleteModal}>
                                        Cancel
                                    </Button>
                                    <Button variant="danger" style={{ color: '#fff', backgroundColor: '#dc3545', border: 'none' }} onClick={handleRemovePackaging}>
                                        Delete
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* View Modal */}
                            <Modal size="lg" show={showViewModal} onHide={handleCloseViewModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Packaging Record Details</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {selectedRecord ? (
                                        <div className="formView">
                                            <p><strong>Code:</strong> {selectedRecord.code ? selectedRecord.code : "n/a"}</p>
                                            <p><strong>Date:</strong> {isoToDate(selectedRecord.date)}</p>
                                            <p><strong>GRAI:</strong> {selectedRecord.grai ? selectedRecord.grai : "n/a"}</p>
                                            <p><strong>GTIN:</strong> {selectedRecord.gtin ? selectedRecord.gtin : "n/a"}</p>
                                            <p><strong>SSCC:</strong> {selectedRecord.sscc ? selectedRecord.sscc : "n/a"}</p>
                                            {runningCompanyId !== CompanyIds.TropighaFarmsLtd &&
                                                <p><strong>Packaging Type:</strong> {selectedRecord.packagingType}</p>
                                            }
                                            <p><strong>Packaging Material:</strong> {selectedRecord.packagingMaterial.join(', ')}</p>
                                            <p><strong>Quantity Packed:</strong> {selectedRecord.quantityPackaged} {selectedRecord.quantityUnit}</p>
                                            <p><strong>Number of Packers:</strong> {selectedRecord.numberOfPackers}</p>
                                            <p><strong>Supervised By:</strong> {selectedRecord.supervisedBy ? selectedRecord.supervisedBy : '--' }</p>
                                            <p><strong>Quality Checks:</strong> {selectedRecord.qualityChecks ? selectedRecord.qualityChecks : '--'}</p>
                                            <p><strong>Issues Identified:</strong> {selectedRecord.issuesIdentified ? selectedRecord.issuesIdentified : '--'}</p>
                                            <p><strong>Corrective Actions:</strong> {selectedRecord.correctiveActions ? selectedRecord.correctiveActions : '--'}</p>
                                            <p><strong>Labelling:</strong> {selectedRecord.labelling ? selectedRecord.labelling : '--'}</p>

                                            {/* Environmental Conditions */}
                                            <hr />
                                            <h4>Environmental Conditions</h4>
                                            {selectedRecord.environmentalCondition ? (
                                                <div>
                                                    <p><strong>Temperature:</strong> {selectedRecord.environmentalCondition.temperature}</p>
                                                    <p><strong>Weather Conditions:</strong> {selectedRecord.environmentalCondition.weatherConditions}</p>
                                                    <p><strong>Humidity:</strong> {selectedRecord.environmentalCondition.humidity ? selectedRecord.environmentalCondition.humidity : "N/A"}</p>
                                                    <p><strong>Rainfall:</strong> {selectedRecord.environmentalCondition.rainfall ? selectedRecord.environmentalCondition.rainfall : "N/A"}</p>
                                                    <p><strong>Wind Speed:</strong> {selectedRecord.environmentalCondition.windSpeed ? selectedRecord.environmentalCondition.windSpeed : "N/A"}</p>
                                                    <p><strong>Recorded Date:</strong> {isoToDate(selectedRecord.environmentalCondition.recordedDate)}</p>
                                                    <p><strong>Effects:</strong> {selectedRecord.environmentalCondition.effects}</p>
                                                </div>
                                            ) : (
                                                <p>No environmental conditions data available.</p>
                                            )}
                                        </div>
                                    ) : (
                                        <p>No record selected.</p>
                                    )}

                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseViewModal}>
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            
                            <Modal size="lg" show={showModal} onHide={handleModalClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>{packagingId ? "Edit Packaging Record" : "Add Packaging Record"}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <PackagingBasicForm
                                        crop={crop}
                                        packagingRecord={packagingRecord}
                                        setPackagingRecord={setPackagingRecord}
                                        handleSubmit={handleSubmit}
                                    />
                                </Modal.Body>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PackagingTable;